import { useMemo, useState } from "react";

import {
  Box,
  VStack,
  Text,
  // Stack,
  HStack,
  CircularProgress,
  IconButton,
} from "@chakra-ui/react";

import { useHistory } from "react-router-dom";

import Button from "../Button/Button";
import { RSelect, OptionLabel } from "../Select/RSelect";
import { ReactComponent as TransactionsIcon } from "assets/svg/transactions-icon.svg";

import useWalletBalance from "hooks/useWalletBalance";
import useCoinInfo from "hooks/useCoinInfo";

import formatter from "util/formatter";
import toLower from "lodash/toLower";
import toCoinLocale from "util/toCoinLocale";

// import useWallet from "hooks/useWalletBalance";
// import { toQueryString } from "util/utils";
// import uniqBy from "lodash/uniqBy";

import selectCountryCurrency from "util/selectCountryCurrency";

// import { AnimatePresence, motion } from "framer-motion";

// const MotionVStack = motion(VStack);

const WalletActions = ({
  coin,
  data,
  // isLoading,
  userData,
  onSelect,
  ...xprops
}) => {
  const history = useHistory();

  const [state, _setState] = useState({ coin });
  const { getWalletInfo } = useCoinInfo();
  const { fiats, getBalance, isLoading } = useWalletBalance();

  const setState = (newState) => _setState(() => ({ ...state, ...newState }));

  const canFundWallet = useMemo(() => {
    const map = {
      nigeria: "ngn",
      ghana: "ghs",
      kenya: "kes",
    };

    return map[toLower(userData?.country ?? "nigeria")] === state?.coin;
  }, [userData, state?.coin]);

  const canWithdrawWallet = useMemo(() => {
    const map = {
      nigeria: { currency: "ngn", enabled: true },
      ghana: { currency: "ghs", enabled: true },
      kenya: { currency: "kes", enabled: false },
    };

    const opt = map[toLower(userData?.country ?? "nigeria")];

    return opt?.currency === state?.coin && opt?.enabled;
  }, [userData, state?.coin]);

  console.log("can withdraw", canWithdrawWallet);

  const balance = useMemo(
    () => getBalance(state?.coin),
    [getBalance, state?.coin]
  );

  const handleSelect = (value) => {
    setState({ coin: value });
    onSelect && onSelect(value);
  };

  const options = useMemo(() => {
    return fiats?.map((fiat) => ({
      label: (
        <OptionLabel
          label={toCoinLocale(fiat?.coin)}
          img={getWalletInfo(fiat?.coin).image}
        />
      ),
      value: fiat?.coin,
    }));
  }, [getWalletInfo, fiats]);

  const defaultValue = useMemo(
    () => options.find((option) => option.value === (state?.coin ?? "ngn")),
    [options, state?.coin]
  );

  return (
    <Box
      bg="#027343"
      border="1px solid #EFF0F6"
      p="24px"
      borderRadius="16px"
      // minH="320px"
      maxW={["100%", "100%", "380px"]}
      {...xprops}
    >
      {isLoading && (
        <VStack py="32px">
          <CircularProgress
            ml="20px !important"
            isIndeterminate
            color="white"
            size="22px"
          />
        </VStack>
      )}
      {!isLoading && balance && (
        <Box>
          <Box>
            <HStack w="100%" justifyContent="space-between">
              <Text color="#FFFFFF8f" fontSize="xs" fontWeight="500">
                Wallet Balance
              </Text>

              <RSelect
                onChange={(e) => handleSelect(e.value)}
                container={{
                  width: "110px",
                  height: "32px",
                  minHeight: "32px",
                }}
                control={{
                  height: "32px",
                  minHeight: "32px",
                  padding: "0 5px",
                  borderRadius: "5px",
                  background: "#ffffff1f",
                  ":hover": {
                    background: "#ffffff1f",
                  },
                }}
                valueContainer={{
                  padding: "0 !important",
                  color: "white",
                  flexWrap: "nowrap",
                  fontSize: "14px",
                  ".chakra-stack": {
                    gridGap: "2px",
                  },
                }}
                dropdownIndicator={{ padding: "0 !important" }}
                isSearchable={false}
                options={options}
                defaultValue={defaultValue}
              />
            </HStack>
            <Text color="#FFFFFF" fontSize="2xl" fontWeight="600">
              {formatter(state?.coin).format(balance)}
            </Text>
          </Box>

          <HStack mt="32px !important" justifyContent="space-between">
            <HStack>
              <Button
                h="40px"
                d="flex"
                justifyContent="center"
                alignItems="center"
                borderRadius="10px"
                color="black"
                maxW="120px"
                minW="120px"
                bg="#D9DBE9"
                variant="unstyled"
                onClick={() =>
                  history.push(`/dashboard/wallet/fund/${state?.coin ?? "ngn"}`)
                }
                disabled={!canFundWallet}
              >
                Fund
              </Button>
              <Button
                h="40px"
                d="flex"
                justifyContent="center"
                alignItems="center"
                borderRadius="10px"
                color="black"
                maxW="120px"
                minW="120px"
                bg="#D9DBE9"
                variant="unstyled"
                onClick={() =>
                  history.push(
                    `/dashboard/wallet/withdraw/${state?.coin ?? "ngn"}`
                  )
                }
                disabled={!canWithdrawWallet}
              >
                Withdraw
              </Button>
            </HStack>
            <IconButton
              size="sm"
              color="#4E4B66"
              bg="transparent"
              _hover={{ bg: "#0000001f" }}
              _active={{ bg: "#0000001f" }}
              _focus={{ shadow: "0 0 0 3px var(--focusColor)" }}
              aria-label="view transactions"
              icon={<Box boxSize="18px" as={TransactionsIcon} />}
              onClick={() =>
                history.push(`/dashboard/wallet/${state?.coin}/transactions`)
              }
            />
          </HStack>
        </Box>
      )}
    </Box>
  );
};

function WrappedFiatWalletAction(props) {
  const { userData, ...xprops } = props;

  const defaultUserCurrency = useMemo(
    () => selectCountryCurrency(userData?.country),
    [userData?.country]
  );

  return (
    <WalletActions
      bg="linear-gradient(114.44deg, #027343 0%, #02AA63 100%)"
      shadow="0px 2px 12px rgba(51, 31, 109, 0.18)"
      // isLoading={isLoading}
      coin={defaultUserCurrency}
      // data={getCoin(defaultUserCurrency)}
      userData={userData}
      {...xprops}
    />
  );
}

export default WalletActions;

export { WrappedFiatWalletAction };
